import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

export interface GetTranslationsHistoryResult {
  items: TranslationsHistoryItem[],
  totalCount: number,
  pageNumber: number,
  maxItems: number
}

export interface TranslationsHistoryItem {
  id: string,
  organization: string,
  userId: string,
  operationType: OperationType,
  status: "created" | "completed" | "error",
  createdDate: string,
  updatedDate: string | null,
  errorDescription: string | null,
  format: FileFormat,
  downloadUrl: string | null,
  surveyId: string,
  importType: "SurveyTranslations" | "GlobalTranslations",
  totalItems: number,
  skipRows: number,
  newTranslation: number,
  updateTranslations: number
}

export type FileFormat = "Excel" | "CSV";
export type OperationType = "Import" | "Export";

@Injectable({ providedIn: 'root' })
export class ApiTranslationsHistoryService {
  private readonly apiBaseUrl = environment.apiBaseUrl;
  private readonly apiPath = '/translations-history';

  constructor(
    private http: HttpClient) {}

  getTranslationsHistory(organizationId: string, surveyId: string | null, operationType: OperationType | null, pageNumber: number, maxItems: number): Observable<GetTranslationsHistoryResult> {
    const params = new HttpParams()
          .set('organizationId', organizationId)
          .set('surveyId', surveyId ?? '')
          .set('operationType', operationType ?? '')
          .set('pageNumber', pageNumber)
          .set('maxItems', maxItems);
        
    return this.http.get<GetTranslationsHistoryResult>(`${this.apiBaseUrl}${this.apiPath}`, {params})
  }
}